import React from 'react'
import PhotoIcon from 'src/images/icons/photo_icon_small.svg'
import ArticleIcon from 'src/images/icons/article_icon_small.svg'
import ScissorsIcon from 'src/images/icons/scissors_icon_small.svg'
import FileIcon from 'src/images/icons/file_icon_small.svg'

class IconMessage extends React.Component {
  imageType() {
    switch (this.props.label) {
      case 'Photo':
      case 'Photos':
      case 'Photos with Captions':
        return PhotoIcon
        break;
      case 'Article':
        return ArticleIcon
        break;
      case 'Remove Pages':
        return ScissorsIcon
        break;
      case 'Add Files':
        return FileIcon
        break;
    }
  }

  render() {
    const linkKlass = this.props.link == undefined ? 'cursor-none' : 'js-no-delete'

    return (
      <div className='d-flex flex-row'>
        <img className='col px-0' style={{'height': '30px', 'marginTop': '2px'}} src={this.imageType()}/>
        <span className='col-10'>
          <h5 className='mb-0 grey-text text-darken-2'>{this.props.label}</h5>
          <a className={linkKlass} href={this.props.link} style={{'fontSize': '12px'}}>{this.props.description}</a>
        </span>
      </div>
      )
  }
}

export default IconMessage
